import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createSurvey, surveyQueryKeys } from '../api/surveys.api';
import type { CreatedSurveyRef, CreateSurveyPayload } from '../types/survey.types';

export function useCreateSurvey(onSuccess?: (survey: CreatedSurveyRef) => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateSurveyPayload) => createSurvey(payload),
    onSuccess: (survey) => {
      void queryClient.invalidateQueries({ queryKey: surveyQueryKeys.lists() });
      toast.success('Survey created successfully');
      onSuccess?.(survey);
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create survey');
    },
  });
}
